import { render, staticRenderFns } from "./changelog-field.vue?vue&type=template&id=34d33b91"
import script from "./changelog-field.vue?vue&type=script&lang=js"
export * from "./changelog-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports